import assert from 'assert';
import moment from 'moment';
import { dateTimeFormats } from './dateFormat';

const requiredVariables = ['REACT_APP_API_SERVER_URL', 'REACT_APP_API_SERVER_WS_URL', 'REACT_APP_BASENAME'];

if (process.env.NODE_ENV !== 'test') {
    requiredVariables.forEach(variable => {
        assert(process.env.hasOwnProperty(variable), `${variable} must be defined in the root .env file`);
    });
}

export const apiServerURL = process.env.REACT_APP_API_SERVER_URL;

export const contextHelpBaseURL = process.env.REACT_APP_CONTEXT_HELP_URL || 'https://storage.googleapis.com/static.clxp.us/tcc';

export const apiServerWSUrl = process.env.REACT_APP_API_SERVER_WS_URL;
const defaultApiWSTimeCheckAlerts = 60000;
export const apiWSTimeCheckAlerts = process.env.REACT_APP_API_WS_CHECK_TIME_PERIOD
    ? parseInt(process.env.REACT_APP_API_WS_CHECK_TIME_PERIOD, 10)
    : defaultApiWSTimeCheckAlerts;
export const mailFromAddress = process.env.REACT_APP_MAIL_FROM_ADDRESS;
export const dirBasename = process.env.REACT_APP_BASENAME;
export const versionNumber = process.env.REACT_APP_VERSION_NUMBER || '';
export const versionRelease =
    moment(process.env.REACT_APP_VERSION_DATE, dateTimeFormats.dateApi).format(dateTimeFormats.dateDefault) || '';
export const dashboardVersion = process.env.REACT_APP_DASHBOARD_VERSION || `v${process.env.npm_package_version || '0.0.0'}`;
export const pushDebug = process.env.REACT_APP_PUSH_DEBUG ? !!Number(process.env.REACT_APP_PUSH_DEBUG) : false;
export const posthogKey = process.env.REACT_APP_POSTHOG_KEY;
